# Phase 4: Hirer identifiers

The SEEK API uses opaque [object identifier] strings to identify SEEK hirers.

Your software may have been using numeric SEEK advertiser IDs for the previous version of Apply with SEEK.
As the [new Apply with SEEK] is brought under the SEEK API,
this legacy format will be phased out to:

- Simplify hirer onboarding,
  as a single identifier can be used across all use cases

- Simplify partner integrations,
  as your software won’t need to decide which identifier is applicable to which use case

- Improve the efficiency and reliability of partner integrations that called the SEEK API on demand to map between identifier formats

```diff label="Identifier format change"
- 10000
+ seekAnzPublicTest:organization:seek:93WyyF1h
```

## Migration considerations

### Converting existing IDs

If your software currently stores SEEK advertiser IDs,
download a CSV of your SEEK hirers from the [Developer Dashboard hirers page].
This includes a mapping between legacy SEEK advertiser IDs and new hirer IDs.

### Onboarding new hirers

SEEK’s hirer onboarding process already provides your software with our new hirer IDs.

Ensure that any corresponding changes made to your software and processes comply with our [hirer onboarding guidance] by enforcing appropriate authorization and validation.

## Exit criteria

At the conclusion of this revision,
your software must internally operate on our new hirer IDs.

Support for the [`seekAnzAdvertiser` query] and related fields across the GraphQL schema will be removed.

[`seekAnzAdvertiser` query]: /schema/query/seekAnzAdvertiser
[Developer Dashboard hirers page]: /manage/hirers
[hirer onboarding guidance]: /auth/hirer-relationships#hirer-onboarding
[new Apply with SEEK]: /guides/2025-revision
[object identifier]: /graphql/seek-api-conventions#object-identifiers
